import React from 'react';
import { JFormik } from '../../../forms';
import * as Yup from 'yup';
import { Chip, IconButton, Tooltip, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

export const DetailsForm = () => {
  return (
    <JFormik
      initialValues={(resource: any) => ({})}
      validationSchema={Yup.object({})}
      handleSubmit={(values: any) => {}}
      containerGridProps={{ spacing: 2 }}
      form={[
        {
          name: 'title',
          label: 'Details',
          itemType: 'typography',
          jItemProps: { variant: 'overline' },
        },
        {
          name: 'title-bottom',
          label: '',
          itemType: 'divider',
          gridProps: {
            sx: { paddingTop: '0px !important', paddingBottom: 1 },
          },
        },
        {
          name: 'subject',
          itemType: 'textfield',
          label: 'Add a subject line',
          gridProps: { xs: 12 },
        },
        {
          name: 'project',
          itemType: 'autocomplete',
          options: [
            { name: 'Lucca Baird', value: 1 },
            { name: 'Option 1', value: 2 },
            { name: 'Option 2', value: 3 },
          ].map(opt => opt.name),
          multiple: true,
          jItemProps: {
            renderTags: (value: readonly string[], getTagProps: any) =>
              value.map((option: string, index: number) => (
                <Chip
                  variant="outlined"
                  color="secondary"
                  label={option}
                  size="small"
                  {...getTagProps({ index })}
                />
              )),
            helperText: (
              <Typography variant="caption" id="tableTitle" component="div">
                <Tooltip title={`Add recipients`}>
                  <IconButton size="small">
                    <Add color="secondary" />
                  </IconButton>
                </Tooltip>{' '}
                Add recipients
              </Typography>
            ),
          },
          label: 'Select Recipients',
          gridProps: { xs: 6 },
        },
        {
          name: 'due_date',
          itemType: 'datepicker',
          label: 'Add due date',
          gridProps: { xs: 6 },
          jItemProps: {
            helperText: (
              <Typography variant="caption" id="tableTitle" component="div">
                <Tooltip title={`Add start date`}>
                  <IconButton size="small">
                    <Add color="secondary" />
                  </IconButton>
                </Tooltip>{' '}
                Add start date
              </Typography>
            ),
          },
        },
        {
          name: 'response_type',
          itemType: 'autocomplete',
          options: [],
          label: 'Response type',
          gridProps: { xs: 12 },
        },
      ]}
    />
  );
};
